/**
 * Map Container Component
 * 
 * Parent component managing the zoomable map view
 */

import React, { useState } from 'react';
import { TerrainMap, AxialCoord } from '../types/terrain';
import { Player } from '../types/player';
import { MicroMap } from './MicroMap';
import './MapContainer.css';

interface MapContainerProps {
  map: TerrainMap;
  initialCenter?: AxialCoord;
  initialZoom?: number;
  onHexSelect?: (coord: AxialCoord) => void;
  hasUnresolvedMonster?: boolean;
  isInCombat?: boolean;
  onZoomChange?: (zoom: number) => void;
  onPlayerMarkerClick?: () => void;
  onDistantHexClick?: (coord: AxialCoord) => void;
  pendingDestination?: AxialCoord | null;
  onAnimationComplete?: () => void;
  isStoryReady?: boolean;
  plannedRoute?: AxialCoord[];
  nextQuestHex?: { q: number; r: number } | null;
  player?: Player; // Player object for accessing selectedMarkerIcon
}

export const MapContainer: React.FC<MapContainerProps> = ({
  map,
  plannedRoute,
  initialCenter,
  initialZoom,
  onHexSelect,
  hasUnresolvedMonster,
  isInCombat = false,
  onZoomChange,
  onPlayerMarkerClick,
  onDistantHexClick,
  pendingDestination,
  player,
  onAnimationComplete,
  isStoryReady = false,
  nextQuestHex = null,
}) => {
  const [center, setCenter] = useState<AxialCoord>(initialCenter || { q: 0, r: 0 });
  
  const handleCenterChange = (coord: AxialCoord) => {
    setCenter(coord);
    if (onHexSelect) {
      onHexSelect(coord);
    }
  };

  return (
    <div className="map-container">
      {/* Map Display - Full Screen */}
      <div className="map-display">
        <MicroMap
          map={map}
          center={center}
          onCenterChange={handleCenterChange}
          hexSize={30}
          initialZoom={initialZoom}
          hasUnresolvedMonster={hasUnresolvedMonster}
          isInCombat={isInCombat}
          onZoomChange={onZoomChange}
          onPlayerMarkerClick={onPlayerMarkerClick}
          onDistantHexClick={onDistantHexClick}
          pendingDestination={pendingDestination}
          onAnimationComplete={onAnimationComplete}
          isStoryReady={isStoryReady}
          plannedRoute={plannedRoute}
          nextQuestHex={nextQuestHex}
          playerData={player}
        />
      </div>
    </div>
  );
};

